import { useRouter } from 'next/router';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import * as Styles from './styles';

function LegalDocumentPendingState() {
    const router = useRouter();

    return (
        <Styles.Wrapper>
            <Styles.TextWrapper>
                <Styles.Text>
                    We have requested your dealer to submit the bank and GST
                    details.
                </Styles.Text>
                <Styles.Text>
                    Once the dealer completes this step, you will be able to
                    start selling the plans.
                </Styles.Text>
                <Styles.LogoutButton>
                    <PrimaryButton onClick={() => router.push('/logout')}>
                        Logout
                    </PrimaryButton>
                </Styles.LogoutButton>
            </Styles.TextWrapper>
        </Styles.Wrapper>
    );
}

export default LegalDocumentPendingState;
